// extracted by mini-css-extract-plugin
module.exports = {"brandcolor":"#163194","brandcolor2":"#2699FB","mainbackgroundcolor":"#fff","label":"V_ct","text":"V_bt"};